<template>
	<v-main>
		<v-dialog
			v-model="dialog"
			width="min(90vw, 1185px, 90vh)"
		>
			<!-- <v-img
				:src="view_img"
				width="100%"
			/> -->
			<z-img
				:storage="view_img"
				width="100%"
				download
			/>
		</v-dialog>
		<div
			ref="topPage"
			class="head-banner pb-12 pb-md-0"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>
									ผลงานของเรา
								</span>
							</div>
							<div class="float-text">
								<h1>ผลงานของเรา</h1>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div style="height: 300px;">
				<z-img
					storage="/images/2.0/portfolio-banner.png"
					max-width="100%"
					height="300"
					extra-class="bg-transparent"
				/>
			</div>
		</div>

		<div
			v-if="hilightList && hilightList.length > 0"
			class="highlight bgGray"
		>
			<div class="grey-red-bg d-none d-md-block" />
			<v-row
				no-gutters
				class="success-story"
			>
				<v-col
					cols="1"
					md="3"
					xl="4"
					class="col d-none d-md-block"
				>
					<div class="red-bg" />
				</v-col>
				<v-col
					col="12"
					md="6"
					xl="4"
					class="text-center py-6"
				>
					<span class="red--text">SUCCESS</span> STORY
				</v-col>
			</v-row>

			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col
						xl="8"
						class="mx-auto px-0 px-md-12"
					>
						<div class="swiper-outside-container">
							<swiper
								ref="swiper"
								class="swiper pb-12"
								:options="swiperOption"
							>
								<swiper-slide
									v-for="(portfolio, n) in hilightList"
									:ref="`slide${n}`"
									:key="n"
								>
									<v-row no-gutters>
										<v-col
											cols="12"
											md="4"
											lg="3"
											class="highlight-img col px-12 pa-md-0"
										>
											<div class="grey-bg d-md-none" />
											<div class="mx-sm-12 ma-md-0 pa-2">
												<v-skeleton-loader
													v-if="loading"
													type="card"
													width="100%"
													class="portfolio-skel"
													tile
													dark
												/>
												<z-img
													v-else
													:storage="portfolio.img"
													width="100%"
													height="100%"
												/>
											</div>
										</v-col>
										<v-col
											cols="12"
											md="8"
											lg="7"
											class="highlight-detail col pa-12 px-6 px-sm-12 pa-md-9 pa-lg-12"
										>
											<div class="red-strip pl-4">
												<h1>{{ portfolio.title }}</h1>
												<h3>{{ portfolio.text }}</h3>
											</div>
										</v-col>
									</v-row>
									<!-- <div class="d-flex">
										<z-img
											:storage="portfolio.img"
											width="300"
											height="300"
										/>
										<div class="pa-12">
											<div class="red-strip pl-4">
												<h1>{{ portfolio.title }}</h1>
												<h3>{{ portfolio.text }}</h3>
											</div>
										</div>
									</div> -->
								</swiper-slide>
								<div
									slot="pagination"
									class="swiper-pagination bullets-white py-2"
								/>
							</swiper>
							<v-btn
								color="white"
								min-width="48"
								elevation="10"
								class="d-none d-md-flex px-0"
								absolute
								tile
								x-large
								@click="swipePrev"
							>
								<v-icon class="red--text">
									mdi-chevron-left
								</v-icon>
							</v-btn>
							<v-btn
								color="red"
								min-width="48"
								elevation="10"
								class="d-none d-md-flex px-0"
								absolute
								tile
								x-large
								@click="swipeNext"
							>
								<v-icon class="white--text">
									mdi-chevron-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="py-5">
			<v-container>
				<v-row>
					<v-col>
						<h1 class="text-center">
							ผลงาน<span class="red--text">ของเรา</span>
						</h1>
					</v-col>
				</v-row>
				<v-row ref="topList">
					<v-col
						xl="8"
						offset-xl="2"
						class="pt-0"
					>
						<v-row class="justify-center">
							<client-only>
								<template v-if="loading">
									<v-col
										v-for="i in 12"
										:key="'portfolio-skel-' + i"
										cols="12"
										sm="6"
										md="4"
										lg="3"
									>
										<v-skeleton-loader
											type="card"
											width="100%"
											class="portfolio-skel"
											tile
											dark
										/>
									</v-col>
								</template>
								<template v-else>
									<v-col
										v-for="portfolio in portfolioList"
										:key="portfolio.id"
										cols="12"
										sm="6"
										md="4"
										lg="3"
									>
										<v-btn
											class="portFolioCard pa-0 d-block"
											width="100%"
											text
											dark
											@click="viewImg(portfolio.image)"
										>
											<div class="mb-2">
												<z-img
													:storage="portfolio.image"
													width="100%"
													download
												/>
											</div>
											<div>
												{{ portfolio.details }}
											</div>
										</v-btn>
									</v-col>
								</template>
							</client-only>
						</v-row>
						<v-row class="pt-5 pb-12">
							<v-col class="text-center px-0 px-md-3">
								<div class="d-flex justify-center justify-md-space-between align-center text-center">
									<div
										class="d-none d-md-block"
										style="white-space: nowrap;"
									>
										<span class="red--text">{{ totalItem }}</span> รายการ
									</div>
									<v-pagination
										v-model="page"
										:length="totalPage"
										:total-visible="10"
									/>
								</div>
								<div
									class="d-md-none text-center"
									style="white-space: nowrap;"
								>
									<span class="red--text">{{ totalItem }}</span> รายการ
								</div>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-main>
</template>

<script>
const doc = 'portfolio'

import { mapActions, mapGetters } from 'vuex'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
	name: 'PORTFOLIO',
	layout: 'default_2',
	scrollToTop: true,

	components: {
		Swiper,
		SwiperSlide
	},

	async fetch(context) {
		await context.store.dispatch('page/initial', {
			doc: doc,
			fullPath: context.route.fullPath
		})
	},

	data:() => ({
		keepAliveActivated: false,
		loading: true,
		dialog: false,
		query: {},
		page: 1,
		total: 0,
		portfolioList: [],
		agentList: [],
		view_img: null,

		hilightList: [
			{
				img: 'https://cdn.tb.co.th/portfolio/2853/portfolio-e6a2.png',
				title: '1 ปีขายไม่ได้ เชื่อ THE BEST 1 สัปดาห์ขายได้',
				text: 'ฝากขายมานานกับเจ้าอื่นแต่ขายไม่ได้พอทำสัญญากับ บริษัท The Best เพียง 1 สัปดาห์ ก็ปิดการขายได้และได้โอนเงินสดโดยไม่ถึงเดือน'
			},
			{
				img: 'https://cdn.tb.co.th/portfolio/2853/portfolio-e6a2.png',
				title: '1 ปีขายไม่ได้ เชื่อ THE BEST 1 สัปดาห์ขายได้',
				text: 'ฝากขายมานานกับเจ้าอื่นแต่ขายไม่ได้พอทำสัญญากับ บริษัท The Best เพียง 1 สัปดาห์ ก็ปิดการขายได้และได้โอนเงินสดโดยไม่ถึงเดือน'
			},
			{
				img: 'https://cdn.tb.co.th/portfolio/2853/portfolio-e6a2.png',
				title: '1 ปีขายไม่ได้ เชื่อ THE BEST 1 สัปดาห์ขายได้',
				text: 'ฝากขายมานานกับเจ้าอื่นแต่ขายไม่ได้พอทำสัญญากับ บริษัท The Best เพียง 1 สัปดาห์ ก็ปิดการขายได้และได้โอนเงินสดโดยไม่ถึงเดือน'
			}
		]
	}),

	computed: {
		...mapGetters({
			head: 'page/head',
		}),

		swiperOption () {
			return {
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					dynamicBullets: true,
					dynamicMainBullets: 3
				},
				// centeredSlides: items !== 4,
				centeredSlidesBounds: true,
				// grabCursor: true,
				slidesPerView: 1,
				slidesPerGroup: 1,
				// spaceBetween: 15,
			}
		},

		totalItem () {
			return new Intl.NumberFormat('th-TH', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(this.total)
		},

		totalPage () {
			return Math.ceil(this.total / 12)
		}
	},

	watch: {
		page (newPage) {
			// this.$nextTick(() => this.$refs.topList.scrollIntoView({ /*behavior: 'smooth',*/ block: 'center' }))
			this.$refs.topList.scrollIntoView({ /*behavior: 'smooth',*/ block: 'start' })

			// Need to extract or clone params obj
			let params = { ...this.query }
			params['page'] = newPage

			this.$router.push({
				path: this.$route.path,
				query: params
			})
		}
	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
			this.query = this.$route.query
		} else if (this.keepAliveActivated) {
			window.scrollTo(0, 0)
			this.query = this.$route.query
			this.search()
		}
	},

	// In case of search criteria change, just let component react to the new data (no need to re-render component)
	beforeRouteUpdate (to, from, next) {
		if (process.client && from.path === to.path) {
			if (window.windowNavigate) {
				window.windowNavigate = false
				this.query = this.$route.query
			} else {
				// window.scrollTo(0, 0)
				this.query = to.query
				this.search()
			}
			next()

			// Navigate back effect after 'beforeRouteUpdate'
			setTimeout(() => {
				if (window.windowNavigate) {
					window.windowNavigate = false
					this.query = this.$route.query
				}
			}, 1500)
		} else {
			next()
		}
	},

	created () {
		if (process.client) {
			this.query = this.$route.query
			this.initCriteria()
			this.search()
		}
	},

	methods: {
		...mapActions({
			getPortfolio: 'page/getPortfolio'
		}),

		initCriteria () {
			if (this.query.page) {
				this.page = parseInt(this.query.page)
			}
		},

		search () {
			this.loading = true
			let params = { ...this.query }

			this.getPortfolio(params).then(obj => {
				this.portfolioList = obj.data
				this.total = obj.total

				this.loading = false
				this.keepAliveActivated = true
			})
		},

		swipePrev () {
			if (this.$refs.swiper.$swiper) {
				this.$refs.swiper.$swiper.slidePrev()
			}
		},
		swipeNext () {
			if (this.$refs.swiper.$swiper) {
				this.$refs.swiper.$swiper.slideNext()
			}
		},

		viewImg (url) {
			this.$nextTick(() => {
				this.view_img = url
			})
			this.dialog = true
		}
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
.head-banner {
	position: relative;

	.float-text {
		position: absolute;
		top: 180px;
		z-index: 2;
	}

	::v-deep .bg-transparent {
		background: transparent !important;
	}
}
.swiper-outside-container {
	position: relative;

	.col {
		box-sizing: border-box;
	}

	& > .v-btn--absolute {
		top: 50%;
    left: -48px;

		&:first-of-type {
			margin-top: -68.5px;
		}
		&:last-of-type {
			margin-top: -16.5px;
		}
	}

	.swiper-pagination::v-deep {
		.swiper-pagination-bullet {
			background-color: #ed1c24;

			&.swiper-pagination-bullet-active::before {
				content: ' ';
				position: absolute;
				top: -2px;
				left: -2px;
				width: 12px;
				height: 12px;
				border: solid 1px #ed1c24;
				border-radius: 50%;
			}
		}

		&.bullets-white {
			.swiper-pagination-bullet {
				background-color: #fff !important;

				&.swiper-pagination-bullet-active::before {
					border-color: #fff !important;
				}
			}
		}
	}

	& ::v-deep .swiper-wrapper {
		height: unset !important;
	}
	& .swiper-slide {
		height: unset !important;
	}
}
.v-pagination ::v-deep {
	position: relative;

	li {
		button {
			border-radius: unset;
			box-shadow: unset;
			height: 34px;
		}

		&:first-child, &:last-child {
			position: absolute;
			right: 0;

			button {
				background-color: #3a3a3a;
				margin: 0;

				// @media (min-width: 600px) {
				// 	margin: auto 10px;
				// }

				i {
					color: #fff;
				}
			}
		}
		&:first-child {
			left: 0;
			right: unset;

			@media (min-width: 960px) {
				right: 34px;
				left: unset;
			}
		}
		&:nth-child(2) {
			@media (min-width: 960px) {
				margin-left: -90px;
			}
		}
	}
}
.highlight {
	position: relative;

	.grey-red-bg {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		width: 55%;
		background: linear-gradient(
			180deg,
			rgba(0,0,0,0) 0, rgba(0,0,0,0) 120px,
			#3a3a3a 120px, #3a3a3a calc(89% + 1px),
			#ed1c24 calc(89% + 1px), #ed1c24 100%);
	}
	.success-story {
		.col {
			position: relative;
			font-size: xxx-large;
			font-weight: 900;
		}

		.red-bg {
			background-color: #ed1c24;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 170px;
		}
	}

	.highlight-img {
		position: relative;

		div:last-child {
			// border: solid 6px #fff;
			background-color: #fff;;
		}

		.grey-bg {
			position: absolute;
			width: 100%;
			height: 20%;
			left: 0;
			bottom: 0;
			z-index: -1;
			background-color: #3a3a3a;
		}
	}
	.highlight-detail {
		position: relative;
		background-color: #3a3a3a;
		color: #fff;

		&::after {
			content: ' ';
			position: absolute;
			top: 100%;
			left: 0;
			right: 0;
			bottom: -48px;
			background-color: #ed1c24;
		}
	}
	.red-strip {
		border-left: solid 4px #c20000;
	}
}
.portFolioCard::v-deep {
	height: auto !important;
	background: none !important;

	&.v-btn {
		white-space: unset !important;
    text-indent: 1.2rem;
    text-align: left;
	}
	.v-btn__content {
		display: block;
	}
}

.portfolio-skel::v-deep {
	.v-skeleton-loader__image {
		height: 0;
		padding-bottom: 100%;
	}
	.v-skeleton-loader__card-heading {
		display: none;
	}
}
</style>
